import React from 'react';
import {Typography} from '~library/atoms/Typography';
import {ImageFilters} from '~/CreateFabricInvitation/routes/EventCreateDesign/components/CardEditor/actions/UyoControl/ImageFilters/ImageFilters';

export const FiltersSection = () => (
  <div className="uyo-control-section">
    <Typography variant="label2" classNames="uyo-control-section-title">
      FILTERS
    </Typography>
    <div className="uyo-control-filters-placeholder">
      <ImageFilters />
    </div>
  </div>
);
